export const requiresBogPayment = (paymentMethod) => (
  paymentMethod === 'online' || paymentMethod === 'card'
);

export const isLocalDevelopmentHost = (hostname) => (
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname.startsWith('192.168.')
);

export const allowsMockPayment = (hostname, storage = window.localStorage) => (
  isLocalDevelopmentHost(hostname) && storage.getItem('mockPayment') === 'true'
);
